/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StopProjection
 */
export interface StopProjection {
    /**
     * Unique identifier for the stop
     * @type {string}
     * @memberof StopProjection
     */
    stopId: string;
    /**
     * Unique identifier for the place
     * @type {string}
     * @memberof StopProjection
     */
    placeId: string;
    /**
     * Unique identifier for the itinerary this stop belongs to
     * @type {string}
     * @memberof StopProjection
     */
    itineraryId: string;
    /**
     * Country name where the place is located
     * @type {string}
     * @memberof StopProjection
     */
    placeAddressCountryName: string;
    /**
     * Latitude coordinate of the place
     * @type {number}
     * @memberof StopProjection
     */
    placeCoordinatesLatitude: number | null;
    /**
     * Longitude coordinate of the place
     * @type {number}
     * @memberof StopProjection
     */
    placeCoordinatesLongitude: number | null;
}

/**
 * Check if a given object implements the StopProjection interface.
 */
export function instanceOfStopProjection(value: object): value is StopProjection {
    if (!('stopId' in value) || value['stopId'] === undefined) return false;
    if (!('placeId' in value) || value['placeId'] === undefined) return false;
    if (!('itineraryId' in value) || value['itineraryId'] === undefined) return false;
    if (!('placeAddressCountryName' in value) || value['placeAddressCountryName'] === undefined) return false;
    if (!('placeCoordinatesLatitude' in value) || value['placeCoordinatesLatitude'] === undefined) return false;
    if (!('placeCoordinatesLongitude' in value) || value['placeCoordinatesLongitude'] === undefined) return false;
    return true;
}

export function StopProjectionFromJSON(json: any): StopProjection {
    return StopProjectionFromJSONTyped(json, false);
}

export function StopProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StopProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'stopId': json['stopId'],
        'placeId': json['placeId'],
        'itineraryId': json['itineraryId'],
        'placeAddressCountryName': json['placeAddressCountryName'],
        'placeCoordinatesLatitude': json['placeCoordinatesLatitude'],
        'placeCoordinatesLongitude': json['placeCoordinatesLongitude'],
    };
}

  export function StopProjectionToJSON(json: any): StopProjection {
      return StopProjectionToJSONTyped(json, false);
  }

  export function StopProjectionToJSONTyped(value?: StopProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stopId': value['stopId'],
        'placeId': value['placeId'],
        'itineraryId': value['itineraryId'],
        'placeAddressCountryName': value['placeAddressCountryName'],
        'placeCoordinatesLatitude': value['placeCoordinatesLatitude'],
        'placeCoordinatesLongitude': value['placeCoordinatesLongitude'],
    };
}

